import { DASHBOARD_MENU_KEYS, SPACE_SUBSCRIPTIONS } from '@/constants';
import flags from '@/store/flags';
import {
  BookBookmark,
  ChartLineUp,
  CreditCard,
  EnvelopeSimple,
  GearSix,
  House,
  Layout,
  Lightning,
  Link,
  Users,
} from '@phosphor-icons/react';
import { SPACE_ACTION, SubscriptionToken } from '@typedream/data';

// Side Menu Behavior
export const OLD_ROUTE_MENU_KEYS = [
  DASHBOARD_MENU_KEYS.SITE_SETTINGS,
  DASHBOARD_MENU_KEYS.USE_CUSTOM_DOMAIN,
  DASHBOARD_MENU_KEYS.BILLING,
  DASHBOARD_MENU_KEYS.COLLABORATORS,
];
export const NEW_ROUTE_MENU_KEYS = [
  DASHBOARD_MENU_KEYS.ANALYTICS,
  DASHBOARD_MENU_KEYS.ALL_SITES,
  DASHBOARD_MENU_KEYS.TEMPLATE,
  DASHBOARD_MENU_KEYS.DASHBOARD,
  DASHBOARD_MENU_KEYS.AUDIENCE,
  DASHBOARD_MENU_KEYS.EMAIL,
];
export const NON_REDIRECT_MENU_KEYS = [DASHBOARD_MENU_KEYS.HELP_AND_RESOURCES];

export interface IMenu {
  icon: React.ReactNode;
  label: string;
  url: string;
  key: string;
  isHighlighted?: boolean;
  isUpgradeBadge?: boolean;
}

export function getGeneralMenus(
  sub: SubscriptionToken,
  featureFlags: { [key: string]: boolean }
): IMenu[] {
  const menus = [
    {
      icon: <House size={16} weight="bold" />,
      label: 'Home',
      url: '',
      key: DASHBOARD_MENU_KEYS.DASHBOARD,
    },
    {
      icon: <GearSix size={16} weight="bold" />,
      label: 'Site Settings',
      url: '/site',
      key: DASHBOARD_MENU_KEYS.SITE_SETTINGS,
    },
    {
      icon: <ChartLineUp size={16} weight="bold" />,
      label: 'Analytics',
      url: '/analytics',
      isUpgradeBadge: !sub?.isAllowed(SPACE_ACTION.ReadBasicAnalytics, SPACE_SUBSCRIPTIONS),
      key: DASHBOARD_MENU_KEYS.ANALYTICS,
    },
    {
      icon: <Users size={16} weight="bold" />,
      label: 'Collaborators',
      url: '/collaborators',
      isUpgradeBadge: !sub?.isAllowed(SPACE_ACTION.InviteMember, SPACE_SUBSCRIPTIONS),
      key: DASHBOARD_MENU_KEYS.COLLABORATORS,
    },
    {
      icon: sub?.isAllowed(SPACE_ACTION.UpdateCustomDomain, SPACE_SUBSCRIPTIONS) ? (
        <Link size={16} weight="bold" />
      ) : (
        <Lightning size={16} weight="bold" />
      ),
      label: sub?.isAllowed(SPACE_ACTION.UpdateCustomDomain, SPACE_SUBSCRIPTIONS)
        ? 'Custom Domain'
        : 'Add Custom Domain',
      url: '/custom_domain',
      isHighlighted: !sub?.isAllowed(SPACE_ACTION.UpdateCustomDomain, SPACE_SUBSCRIPTIONS),
      key: DASHBOARD_MENU_KEYS.USE_CUSTOM_DOMAIN,
    },
  ];

  if (featureFlags[flags.EmailMarketing]) {
    menus.push({
      icon: <EnvelopeSimple size={16} weight="bold" />,
      label: 'Audience',
      url: '/audience',
      key: DASHBOARD_MENU_KEYS.AUDIENCE,
    });
  }

  return menus;
}

export const OPTION_MENUS = [
  {
    icon: <BookBookmark size={16} weight="bold" />,
    label: 'Help & resources',
    url: '/',
    key: DASHBOARD_MENU_KEYS.HELP_AND_RESOURCES,
  },
  {
    icon: <Layout size={16} weight="bold" />,
    label: 'Templates',
    url: '/template',
    key: DASHBOARD_MENU_KEYS.TEMPLATE,
  },
  {
    icon: <CreditCard size={16} weight="bold" />,
    label: 'Billing',
    url: '/billing',
    key: DASHBOARD_MENU_KEYS.BILLING,
  },
];
